//  -*-web-*-
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
    formControl: {
	margin: theme.spacing(1),
	minWidth: 120,
    },
}));

export function ChartSelect(props) {
    const classes = useStyles();
    
    const handleValue = (e) => {
	if (props.onClick) props.onClick(props, e.target.value);
    };
    
    const itemList = props.items.map((i) =>
	<MenuItem key={i} value={i}>{i}</MenuItem>
    );

    return (
	<div>
	<FormControl className={classes.formControl}>
	<InputLabel>{props.label}</InputLabel>
	<Select value={props.val.toString()} onChange={handleValue} >
	{itemList}
	</Select>
	</FormControl>
	</div>
    );
}

